import axiosInstance from ".";

export const getWork = (term = "") => {
  return axiosInstance.get("/works", {
    params: {
      term: term, 
    },
  });
};


export const addWork= (data) => {
  return axiosInstance.post("/works", data);
};

export const updateWork = (data) => {
  const { id, ...payload } = data;
  return axiosInstance.put(`/works/${id}`, payload);
};

export const addWorkItem = (data) => {
  const { id, ...rest } = data;
  return axiosInstance.post(`/works/${id}/work-item`, rest);
}

export const getWorkByItem = (query) => {
  return axiosInstance.get(`/works/${query?.queryKey?.[1]}/work-item/${query?.queryKey?.[2]}`);
};

export const updateWorkByItem = (data) => {
  const { id, itemId, ...payload } = data;
  return axiosInstance.put(`/works/${id}/work-item/${itemId}`, payload);
};

export const deleteWorkItem = (data) => {
  const { id, itemId, ...payload } = data;
  return axiosInstance.delete(`/works/${id}/work-item/${itemId}`, payload);
};